<template>
  <div
    v-if="isLoading"
    class="p-20 flex justify-center"
  >
    <BaseSpinner />
  </div>
  <div v-else>
    <RecentPagePdfButton v-if="enableDownloadPDFButton" class="absolute right-2 top-10" :page-id="'department-' + department.id" />
    <h1 class="p-4 md:p-8 pb-2 mb-0">Departments: {{ department.displayName }}</h1>
    <p
      v-if="department.catalogDescription && enableCatalogDescriptions"
      class="md:px-8 md:pb-8"
      data-test="curriculumDepartmentCatalogDescription"
    >
      {{ department.catalogDescription }}
    </p>
    <ul class="flex border-b px-4 md:px-8">
      <li
        v-for="tab of tabs"
        :key="tab.to"
        class="-mb-px mr-1"
      >
        <nuxt-link
          class="bg-white inline-block py-2 px-2 md:px-4 text-blue-600 font-semibold ui-font"
          :to="`/departments/${encodeURIComponent($route.params.id)}/${tab.to}`"
        >
          {{ tab.label }}
        </nuxt-link>
      </li>
    </ul>
    <div class="px-4 md:px-8 pb-8 pt-2">
      <nuxt-child
        keep-alive
        :department="department"
        :page="page"
      />
    </div>
  </div>
</template>

<script>
import RecentPagePdfButton from '@/components/RecentPagePdfButton.vue'
import useFeatureFlags from '@/composables/useFeatureFlags'
import {
  DEPARTMENT_CATALOG_DESCRIPTIONS,
  DEPARTMENT_PAGE_PDF,
} from '@/constants/featureFlags'
import useMeta from '@/composables/useMeta'

export default {
  components: { RecentPagePdfButton },
  setup() {
    const {
      enableCatalogDescriptions,
      enableDownloadPDFButton,
    } = useFeatureFlags({
      enableCatalogDescriptions: DEPARTMENT_CATALOG_DESCRIPTIONS,
      enableDownloadPDFButton: DEPARTMENT_PAGE_PDF,
    })
    const { catalogWideMetaTitle } = useMeta()
    return { enableCatalogDescriptions, enableDownloadPDFButton, catalogWideMetaTitle }
  },
  data() {
    return {
      department: {},
      page: {},
      isLoading: true,
    }
  },
  head() {
    return {
      title: `${this.department.displayName} Department | ${
        this.catalogWideMetaTitle
      }`,
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: `${this.department.displayName} Department | ${
            this.catalogWideMetaTitle
          }`,
        },
      ],
    }
  },
  computed: {
    tabs() {
      return [
        { to: 'overview', label: 'Overview' },
        { to: 'courses', label: 'Courses' },
        { to: 'programs', label: 'Programs' },
      ]
    },
  },
  async created() {
    const url = `/ca/${this.$store.state.settings.school}/catalogPages/${
      this.$store.state.settings.activeCatalog
    }/department-${this.$route.params.id}`

    const [department = {}, page = {}] = await Promise.all([
      this.$axios.get(
        `/${this.$store.state.settings.school}/departments/${encodeURIComponent(
          this.$route.params.id
        )}`
      ),
      this.$axios.get(url).catch((e) => {
        console.warn('Missing department page')
      }),
    ])

    this.department = department.data
    this.page = page.data
    this.isLoading = false
  },
}
</script>

<style lang="css" scoped>
.nuxt-link-active {
  @apply border-l border-t border-r rounded-t;
}
.ui-font,
.ui-font:hover,
.ui-font:focus {
  font-weight: var(--interfaceFontWeight, inherit);
  color: var(--interfaceFontColor, inherit);
}
</style>
